
import React from 'react';
import { Button } from '@/components/ui/button';
import { useFollow } from '@/hooks/useFollow';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2, UserPlus, UserMinus } from 'lucide-react';

interface FollowButtonProps {
  targetUserId: string;
  className?: string;
  size?: 'sm' | 'default' | 'lg';
  variant?: 'default' | 'outline';
}

const FollowButton = ({ 
  targetUserId, 
  className = '', 
  size = 'sm',
  variant = 'default'
}: FollowButtonProps) => {
  const { user } = useAuth();
  const { isFollowing, isToggling, toggleFollow } = useFollow(targetUserId);

  // Don't show button for own profile or when not logged in
  if (!user || user.id === targetUserId) {
    return null;
  }

  return (
    <Button
      onClick={toggleFollow}
      disabled={isToggling}
      size={size}
      variant={isFollowing ? 'outline' : 'default'}
      className={`
        ${isFollowing 
          ? 'border-pet-purple text-pet-purple hover:bg-pet-purple hover:text-white' 
          : 'bg-pet-purple hover:bg-pet-purple/90 text-white'
        } 
        flex items-center gap-1 ${className}
      `}
    >
      {isToggling ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : isFollowing ? (
        <>
          <UserMinus className="h-4 w-4" />
          Following
        </>
      ) : (
        <>
          <UserPlus className="h-4 w-4" />
          Follow
        </>
      )}
    </Button>
  );
};

export default FollowButton;
